import { Flex, Box } from "@chakra-ui/react";
import ListingPageHeaderBar from "components/Page/ListingPageHeaderBar/index";
import ItemAuditoria from "../ItemAuditoria";
import FilterTag from "./FilterTag";
import { RelatorioAuditoriaQueryParams } from "core/features/relatorios/typings/index";
import ModalFiltroAuditoria from "../ModalFiltroAuditoria/index";
import { useState } from "react";
import { RelatorioAuditoriaItem } from "core/features/relatorios/typings";
import { Skeleton } from "@chakra-ui/react";
import { Empty } from "antd";
import InfiniteScrollCardList from "ui/components/InfiniteScrollCardList";

interface RelatorioAuditoriaContentProps {
  data: RelatorioAuditoriaItem[];
  isLoading: boolean;
  fetchNextPage: () => any;
  hasNextPage: boolean;
  filtro: RelatorioAuditoriaQueryParams;
  onChangeFiltro: (_filtro: Partial<RelatorioAuditoriaQueryParams>) => void;
  onResetFiltro: () => void;
  isFetchingNextPage?: boolean;
}

export default function RelatorioAuditoriaContent({
  filtro,
  onChangeFiltro,
  onResetFiltro,
  data,
  isLoading,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
}: RelatorioAuditoriaContentProps) {
  const [isOpenModalFiltro, setIsOpenModalFiltro] = useState(false);

  return (
    <>
      <ListingPageHeaderBar
        valueSearch={filtro.search}
        onSearch={(search) => onChangeFiltro({ search })}
        onFiltro={() => setIsOpenModalFiltro(true)}
        visibleFiltro
        children={
          <Flex flexWrap="wrap">
            <FilterTag filtro={filtro} onChangeFiltro={onChangeFiltro} />
          </Flex>
        }
      />

      <Box mt={4}>
        {isLoading ? (
          <>
            <Skeleton w="100%" h="200px" />
          </>
        ) : null}

        {!isLoading && !data.length ? (
          <Empty description="Sem itens para esse filtro" />
        ) : null}

        {!isLoading && data.length ? (
          <>
            <InfiniteScrollCardList
              isLoading={isLoading}
              isFetchingNextPage={isFetchingNextPage}
              data={data}
              hasMore={!!hasNextPage}
              defaultCardSize={90}
              onNext={fetchNextPage}
              emptyDescription="Sem eventos para esse filtro"
              RenderCard={({ item }) => (
                <ItemAuditoria key={item.id} item={item} />
              )}
            />
          </>
        ) : null}
      </Box>

      <ModalFiltroAuditoria
        filtro={filtro}
        onReset={onResetFiltro}
        visible={isOpenModalFiltro}
        onClose={() => setIsOpenModalFiltro(false)}
        onChangeFiltro={onChangeFiltro}
      />
    </>
  );
}
